import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { AlertProps } from '@business/interfaces/alert';
import { SVGAssets } from '@business/assets/vectors';

export const Alert: React.FC<AlertProps> = ({
  type = 'error',
  message,
  onClose = () => {},
  className,
  wrapperClass,
  autoHide = true,
  autoHideDuration = 10000,
  isFocusable = true,
  isWidthFull = false
}) => {
  const alertRef = useRef(null);
  useEffect(() => {
    if (isFocusable) {
      alertRef.current.scrollIntoView({ block: 'center' });
    }
    if (autoHide) {
      setTimeout(() => {
        onClose();
      }, autoHideDuration);
    }
  }, []);
  return (
    <div className={`flex justify-end w-full ${wrapperClass ?? ''}`}>
      <div
        ref={alertRef}
        className={classNames(
          `alert flex items-center justify-between px-4 py-2 rounded-lg overflow-hidden font-poppins text-xs ${isWidthFull ? 'w-full' : 'w-auto max-w-md'}`,
          {
            'alert-error bg-error border-error text-error': type === 'error',
            'alert-success bg-success border-success text-success':
              type === 'success',
            'alert-warning bg-warning border-warning text-warning':
              type === 'warning'
          },
          className
        )}
        role="alert"
        aria-live="assertive">
        <div className="flex items-center">
          <span className="alert-message">{message}</span>
        </div>
        <button
          onClick={onClose}
          className="alert-close-button ml-4 text-xs"
          aria-label="Close alert">
          <SVGAssets.AlertCross className="w-8 h-7 inline-block" />
        </button>
      </div>
    </div>
  );
};

export default Alert;
